/**
 * ForStraction service API
 * Lead your organisation’s full potential to creating results
 *
 * OpenAPI spec version: 2.0.1639219082
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

(function(root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define(['ApiClient'], factory);
  } else if (typeof module === 'object' && module.exports) {
    // CommonJS-like environments that support module.exports, like Node.
    module.exports = factory(require('../ApiClient'));
  } else {
    // Browser globals (root is window)
    if (!root.ForStractionServiceApi) {
      root.ForStractionServiceApi = {};
    }
    root.ForStractionServiceApi.StrategyExportItemSettings = factory(root.ForStractionServiceApi.ApiClient);
  }
}(this, function(ApiClient) {
  'use strict';




  /**
   * The StrategyExportItemSettings model module.
   * @module model/StrategyExportItemSettings
   * @version 2.0.1639219082
   */

  /**
   * Constructs a new <code>StrategyExportItemSettings</code>.
   * @alias module:model/StrategyExportItemSettings
   * @class
   */
  var exports = function() {
    var _this = this;






















  };

  /**
   * Constructs a <code>StrategyExportItemSettings</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/StrategyExportItemSettings} obj Optional instance to populate.
   * @return {module:model/StrategyExportItemSettings} The populated <code>StrategyExportItemSettings</code> instance.
   */
  exports.constructFromObject = function(data, obj) {
    if (data) {
      obj = obj || new exports();

      if (data.hasOwnProperty('PublishTargetEntityTypeID')) {
        obj['PublishTargetEntityTypeID'] = ApiClient.convertToType(data['PublishTargetEntityTypeID'], 'Integer');
      }
      if (data.hasOwnProperty('PublishTargetEntityID')) {
        obj['PublishTargetEntityID'] = ApiClient.convertToType(data['PublishTargetEntityID'], 'Integer');
      }
      if (data.hasOwnProperty('EntityID')) {
        obj['EntityID'] = ApiClient.convertToType(data['EntityID'], 'Integer');
      }
      if (data.hasOwnProperty('EntityParentID')) {
        obj['EntityParentID'] = ApiClient.convertToType(data['EntityParentID'], 'Integer');
      }
      if (data.hasOwnProperty('EntityTypeID')) {
        obj['EntityTypeID'] = ApiClient.convertToType(data['EntityTypeID'], 'Integer');
      }
      if (data.hasOwnProperty('Name')) {
        obj['Name'] = ApiClient.convertToType(data['Name'], 'String');
      }
      if (data.hasOwnProperty('Description')) {
        obj['Description'] = ApiClient.convertToType(data['Description'], 'String');
      }
      if (data.hasOwnProperty('ResponsibleUserID')) {
        obj['ResponsibleUserID'] = ApiClient.convertToType(data['ResponsibleUserID'], 'Integer');
      }
      if (data.hasOwnProperty('CompanyFunctionID')) {
        obj['CompanyFunctionID'] = ApiClient.convertToType(data['CompanyFunctionID'], 'Integer');
      }
      if (data.hasOwnProperty('CompanyVirtualTeamID')) {
        obj['CompanyVirtualTeamID'] = ApiClient.convertToType(data['CompanyVirtualTeamID'], 'Integer');
      }
      if (data.hasOwnProperty('StartDate')) {
        obj['StartDate'] = ApiClient.convertToType(data['StartDate'], 'Date');
      }
      if (data.hasOwnProperty('AchievedByDate')) {
        obj['AchievedByDate'] = ApiClient.convertToType(data['AchievedByDate'], 'Date');
      }
      if (data.hasOwnProperty('ProgressCalculationMethodID')) {
        obj['ProgressCalculationMethodID'] = ApiClient.convertToType(data['ProgressCalculationMethodID'], 'Integer');
      }
      if (data.hasOwnProperty('ProgressCalculationSourceID')) {
        obj['ProgressCalculationSourceID'] = ApiClient.convertToType(data['ProgressCalculationSourceID'], 'Integer');
      }
      if (data.hasOwnProperty('MetricName')) {
        obj['MetricName'] = ApiClient.convertToType(data['MetricName'], 'String');
      }
      if (data.hasOwnProperty('TargetValue')) {
        obj['TargetValue'] = ApiClient.convertToType(data['TargetValue'], 'Number');
      }
      if (data.hasOwnProperty('ForcePublish')) {
        obj['ForcePublish'] = ApiClient.convertToType(data['ForcePublish'], 'Boolean');
      }
      if (data.hasOwnProperty('SendNotification')) {
        obj['SendNotification'] = ApiClient.convertToType(data['SendNotification'], 'Boolean');
      }
      if (data.hasOwnProperty('CategoryID')) {
        obj['CategoryID'] = ApiClient.convertToType(data['CategoryID'], 'Integer');
      }
      if (data.hasOwnProperty('CategoryName')) {
        obj['CategoryName'] = ApiClient.convertToType(data['CategoryName'], 'String');
      }
      if (data.hasOwnProperty('ID')) {
        obj['ID'] = ApiClient.convertToType(data['ID'], 'Integer');
      }
    }
    return obj;
  }

  /**
   * @member {Integer} PublishTargetEntityTypeID
   * @default 0
   */
  exports.prototype['PublishTargetEntityTypeID'] = 0;
  /**
   * @member {Integer} PublishTargetEntityID
   * @default 0
   */
  exports.prototype['PublishTargetEntityID'] = 0;
  /**
   * @member {Integer} EntityID
   * @default 0
   */
  exports.prototype['EntityID'] = 0;
  /**
   * @member {Integer} EntityParentID
   */
  exports.prototype['EntityParentID'] = undefined;
  /**
   * @member {Integer} EntityTypeID
   * @default 0
   */
  exports.prototype['EntityTypeID'] = 0;
  /**
   * @member {String} Name
   * @default ''
   */
  exports.prototype['Name'] = '';
  /**
   * @member {String} Description
   * @default ''
   */
  exports.prototype['Description'] = '';
  /**
   * @member {Integer} ResponsibleUserID
   */
  exports.prototype['ResponsibleUserID'] = undefined;
  /**
   * @member {Integer} CompanyFunctionID
   */
  exports.prototype['CompanyFunctionID'] = undefined;
  /**
   * @member {Integer} CompanyVirtualTeamID
   */
  exports.prototype['CompanyVirtualTeamID'] = undefined;
  /**
   * @member {Date} StartDate
   */
  exports.prototype['StartDate'] = undefined;
  /**
   * @member {Date} AchievedByDate
   */
  exports.prototype['AchievedByDate'] = undefined;
  /**
   * @member {Integer} ProgressCalculationMethodID
   */
  exports.prototype['ProgressCalculationMethodID'] = undefined;
  /**
   * @member {Integer} ProgressCalculationSourceID
   */
  exports.prototype['ProgressCalculationSourceID'] = undefined;
  /**
   * @member {String} MetricName
   * @default ''
   */
  exports.prototype['MetricName'] = '';
  /**
   * @member {Number} TargetValue
   */
  exports.prototype['TargetValue'] = undefined;
  /**
   * @member {Boolean} ForcePublish
   * @default false
   */
  exports.prototype['ForcePublish'] = false;
  /**
   * @member {Boolean} SendNotification
   * @default false
   */
  exports.prototype['SendNotification'] = false;
  /**
   * @member {Integer} CategoryID
   */
  exports.prototype['CategoryID'] = undefined;
  /**
   * @member {String} CategoryName
   * @default ''
   */
  exports.prototype['CategoryName'] = '';
  /**
   * @member {Integer} ID
   * @default 0
   */
  exports.prototype['ID'] = 0;



  return exports;
}));


